
import {defineComponent} from "vue";
import CbFormTextWithTitle from "@/components/layouts/content-blocks/forms/CbFormTextWithTitle.vue";
import {PageDetailModeEnum} from "@/models/enum/PageDetailModeEnum";

export default defineComponent({
  name: "OrderLabelContentBlocksDetail",
  computed: {
    PageDetailModeEnum() {
      return PageDetailModeEnum
    }
  },
  components: {CbFormTextWithTitle},
  props: ['mode'],
  data() {
    return {
      cbId: this.$route.params.id as String,
    };
  },
  mounted() {
    const menuItem = document.getElementById('content-detail');
    if (menuItem != null) {
      menuItem.classList.add('active', 'router-link-exact-active');
    }
  }
});
